import React from "react";
import PropTypes from "prop-types";
import grid from "./grid.scss";

export default class Row extends React.PureComponent {
  rowClasses() {
    const colCountXs = `num_xs_${this.props.colCountXs}`;
    const colCountSm = `num_sm_${this.props.colCountSm}`;
    const colCountMd = `num_md_${this.props.colCountMd}`;
    const colCountLg = `num_lg_${this.props.colCountLg}`;
    let sizeClasses =
      this.props.colCountXs && this.props.colCountXs >= 0
        ? `${grid[colCountXs]} `
        : "";
    sizeClasses +=
      this.props.colCountSm && this.props.colCountSm >= 0
        ? `${grid[colCountSm]} `
        : "";
    sizeClasses +=
      this.props.colCountMd && this.props.colCountMd >= 0
        ? `${grid[colCountMd]} `
        : "";
    sizeClasses +=
      this.props.colCountLg && this.props.colCountLg >= 0
        ? `${grid[colCountLg]}`
        : "";
    return `${grid.row} ${
      this.props.className ? this.props.className : ""
    }`.trim();
  }

  render() {
    return <div className={this.rowClasses()}>{this.props.children}</div>;
  }
}

/** Props **/
Row.defaultProps = {
  colCount: null,
  colCountXs: null,
  colCountSm: null,
  colCountMd: null,
  colCountLg: null,
  children: null,
};

Row.propTypes = {
  colCount: PropTypes.number,
  colCountXs: PropTypes.number,
  colCountSm: PropTypes.number,
  colCountMd: PropTypes.number,
  colCountLg: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
